import Image from "next/image";
import classNames from "classnames/bind";
import { useMutation } from "@apollo/client";
import { Button } from "@aqar-app/aqar-design-system";
import { useRouter } from "next/router";
import { useEffect } from "react";
import PropTypes from "prop-types";
import { Icon } from "@/components/icon";
import { REPORT_NOT_FOUND_PAGE } from "../../graphql/mutations/report";
import styles from "./404.module.scss";

const cx = classNames.bind(styles);
export default function Aqar404({
  errorCode,
  rawError,
  actions,
  iconItem,
  errorHeader,
}) {
  const router = useRouter();
  const [reportNotFound] = useMutation(REPORT_NOT_FOUND_PAGE);
  useEffect(() => {
    if (errorCode === 404) {
      reportNotFound({
        variables: {
          path: router.asPath,
          referral: document.referrer,
          code: errorCode?.toString(),
          rawError,
        },
      });
    }
  }, []);

  return (
    <div className={styles.container}>
      {errorCode === 404 ? (
        <Image
          src="/notFound.png"
          width={360}
          height={200}
          className={styles.headerIcon}
          alt="not found"
        />
      ) : (
        iconItem || (
          <Icon
            name="404-not-found"
            width={100}
            height={100}
            className={styles.headerIcon}
            alt="crached"
          />
        )
      )}
      <div className={styles.note}>
        <h4 className={styles.msg}>
          {errorHeader || (errorCode === 404 ? "نأسف لهذا!" : "حصل خطأ ما! ")}
        </h4>
        <span>{rawError || "الصفحة التي طلبتها غير موجودة"}</span>
      </div>
      <div className={styles.actionsContainer}>
        <Button
          className={styles.actionButton}
          contentClassName={styles.btnContent}
          label={actions[0]?.label || "عُد الى الصفحة الرئيسية"}
          priority="primary"
          onClick={() => router.push(actions[0]?.link || "/")}
        />
        {errorCode !== 404 && (
          <Button
            className={cx(styles.actionButton, styles.secondaryBtn)}
            contentClassName={styles.btnContent}
            label={actions[1]?.label || "تواصل مع الدعم الفني"}
            priority="secondary"
            onClick={() =>
              router.push(actions[1]?.link || "/تواصل-معنا#support")
            }
          />
        )}
      </div>
    </div>
  );
}

Aqar404.propTypes = {
  iconItem: PropTypes.node,
  actions: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, link: PropTypes.string }),
  ),
  errorCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rawError: PropTypes.string,
  errorHeader: PropTypes.string,
};

Aqar404.defaultProps = {
  iconItem: undefined,
  errorHeader: "",
  actions: [],
  errorCode: 404,
  rawError: undefined,
};
